import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

export interface ICardActionButtonUIStateProps {
    isSelected: boolean;
    buttonText: string;
    disabled: boolean;
}

export interface ICardActionButtonUIDispatchProps {
    onClick: { () };
}

export interface ICardActionButtonUIProps extends ICardActionButtonUIStateProps, ICardActionButtonUIDispatchProps {
}

export interface ICardActionButtonUIState {
}

export default class CardActionButtonUI extends Component<ICardActionButtonUIProps, ICardActionButtonUIState> {
    static propTypes = {
    };

    handleClick() {
        if (this.props.onClick) {
            this.props.onClick();
        }
    }

    getButtonContent() {
        if (this.props.isSelected) {
            return <i className="fa fa-check"></i>;
        } else {
            return <span>{this.props.buttonText}</span>;
        }
    }

    render() {
        return (
            <div className="dr-ui-package-price-add-btn">
                <button disabled={this.props.disabled}
                        className="btn btn-secondary btn-sm btn-block"
                        type="button"
                        onClick={() => { this.handleClick(); }} >
                    {this.getButtonContent()}
                </button>
            </div>
        );
    }
}
